function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

(function () {
  ServiceCalendarController.$inject = ["API_URL", "$http", "$rootScope"];
  angular.module('calendarApp').controller('ServiceCalendarController', ServiceCalendarController);

  function ServiceCalendarController(API_URL, $http, $rootScope) {
    var serv = this,
        throbber = $rootScope.throbber;
    localStorage.setItem('calendar-type', 'SERVICE');
    serv.orgID = smooth.orgid;
    serv.chosenServices = {};
    serv.init =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var appointments, loggedIn, unreserve;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              serv.finishedLoading = false;
              $rootScope.timeSettings = smooth.timeSettings;
              delete $rootScope.newAppointments;
              localStorage.removeItem('payment-state'); // Delete all tentative appointments against the customer

              _context.prev = 4;
              // If there are previously reserved appointments, delete them as it will cause a mess
              // if the user chooses a new service
              appointments = localStorage.getItem('reserved-appointments') ? JSON.parse(localStorage.getItem('reserved-appointments')) : [], loggedIn = !!($rootScope.customerInfo && $rootScope.customerInfo.email);

              if (!appointments.length) {
                _context.next = 15;
                break;
              }

              appointments = appointments.map(function (appt) {
                return {
                  _id: appt._id
                };
              });
              _context.t0 = loggedIn && appointments && appointments.length;

              if (!_context.t0) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return $http.put(API_URL + '/api/v1/calendar/appointment/unreserve', {
                appointments: appointments
              });

            case 12:
              _context.t0 = _context.sent;

            case 13:
              unreserve = _context.t0;
              localStorage.removeItem('reserved-appointments');

            case 15:
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t1 = _context["catch"](4);
              console.error("Error unreserving appointments");

            case 20:
              throbber.show(); // To start with, only show a list of services / resources

              $http.get(API_URL + '/api/v1/services/' + smooth.orgid + '?getcost=true&enabledonly=true').then(function (reply) {
                throbber.hide();
                var response = reply.data;

                if (!response.success) {
                  throbber.showError('Sorry there was an error with this request: ' + response.msg);
                  return;
                }

                serv.services = response.services;
              });

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[4, 17]]);
    })); // end init

    serv.init();

    serv.toggleService = function (serviceID) {
      serv.chosenServices[serviceID] = !serv.chosenServices[serviceID];
    };
  }
})();